module.exports = __webpack_public_path__ + "img/rune-solid.0ce95ff2.svg";